module.exports = __webpack_public_path__ + "static/media/AnswerRanking.a11ec245.svg";